import styled from "styled-components";

const Style = styled.div`
  background: #ECFDF3;
  display: flex;
  gap: 7px;
  padding: 4px 10px;
  border-radius: 16px;
  width: fit-content;
  
  .legend-cont {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .legend {
      width: 5px;
      height: 5px;
      border-radius: 100%;
      background: #039855;
    }
  }

  span {
    color: #039855;
    font-size: 12px;
  }

  &.moderate {
    background: #FFFAEB;

    .legend {
      background: #DC6803;
    }

    span {
      color: #DC6803;
    }
  }

  &.major {
    background: #FEF3F2;

    .legend {
      background: #D92D20;
    }

    span {
      color: #D92D20;
    }
  }
`;

export default function SeverityTag({ t = (s) => s, value }) {
  const _renderLabel = () => {
    switch (value) {
      case 'moderate':
        return t('Moderate');
      case 'major':
        return t('Major');
      default: 
        return t('Minor');
    }
  };

  return (
    <Style className={value}>
      <div className="legend-cont">
        <div className="legend" />
      </div>
      <span>{_renderLabel()}</span>
    </Style>
  )
}
